<template>
    <div class="mx-auto" style="width: 80%;">
        <h1 class="app-title p-4">GUIA DE HONORÁRIOS SFEPGE</h1>
        <div>
            <b-col xs="12" md="12" class="mx-auto">
                <div id="messages" v-if="messageModal.message !== null">
                    <b-alert show :variant="messageModal.variant">{{ messageModal.message }}</b-alert>
                </div>
        </b-col>
        </div>
        
        <div class="col-12">
            <p class="p-2" style="color: red">
                A partir de janeiro/2023, as guias de parcelamento de honorários devidos ao FEPGE são disponibilizadas por e-mail, encaminhadas diretamente à conta de e-mail do contribuinte cadastrada em nossa base de dados. Caso não venha recebendo as parcelas no seu e-mail, favor entrar em contato com a Central de Atendimento da PGE: Telefones: (41) 3281-6300 e (41) 3281-6250.
            </p>
            <p class="p-2" style="color: red">
                Em razão do processamento dos pagamentos registrados na rede bancária, os boletos das parcelas somente estarão disponíveis para impressão <b>a partir do dia 15 de cada mês.</b>
            </p>
        </div>
      <b-form @submit="onSubmit" @reset="onReset" v-if="show">
        <div class="col-12">
            <b-form-group @click="check()" 
                class="mt-4" id="input-group-4" 
                label="Informe o CPF / CNPJ do contribuinte:" label-for="input-3">
                <b-form-input
                    id="input-1"
                    v-model="form.documento"
                    placeholder="Seu CPF ou CNPJ"
                    required
                    v-mask="['XX.XXX.XXX', 'XXX.XXX.XXX-XX', 'XX.XXX.XXX/XXXX-##']"
                    :class="'cpfCnpj ' + (!validations.cpf.valid ? 'is-invalid' : '')"
                ></b-form-input>   
                <span v-if="!validations.cpf.valid && validations.cpf.invalidDocument" class="invalid-message">Documento inválido!</span>     
            </b-form-group>
        </div>
        <div  class="col-12">
            <b-form-group @click="check()"
                class="mt-4 mb-2"
                id="input-group-1"
                label="Informe o E-mail cadastrado em nossa base:"
                label-for="input-1">
            <b-form-input
                id="input-1"
                v-model="form.email"
                type="email"
                placeholder="Seu email"
                required 
                :change="validarEmail"
                :class="!validations.email.valid ? 'is-invalid' : ''" />
            <div v-if="!validations.email.valid" class="invalid-message">E-mail inválido!</div>
            
            </b-form-group>
        </div>
            <div class="col-8 mb-4 mt-2">
                <b-button class="mr-4 mt-4" type="submit" 
                    icon="sucher" variant="primary" :disabled="!validarObrigatorios">
                    Consultar<i class="ml-2 fa fa-arrow-right"></i>
                </b-button>
                <b-button class="ml-4 mt-4" @click="limpar" icon="sucher" variant="primary">
                    Limpar<i class="ml-2 fa fa-paint-brush"></i>
                </b-button>
            </div>

        </b-form>
      
        <div class="col-12 mt-2 mb-4">
            
            <b-table ref="tabelaBoletos" 
                :items="boletos" 
                :fields="fields"
                :filter="filtros"
                :filter-included-fields="filterOn"
                :sort-by.sync="configTable.sortField"
                :sort-desc.sync="configTable.sortDesc"
                :sort-direction="configTable.setOrder"
                striped
                small
                responsive="sm"
                :busy="false"
                hover
                bordered
                sort-icon-right
                class="mb-0 col-12 tabelaModal"
                head-variant="light"
                selectable
                @row-selected="boletoSelecionado"
                select-mode="single">
                <div slot="table-busy" class="text-center text-primary my-2">
                    <b-spinner class="align-middle"></b-spinner>
                    <strong> Carregando...</strong>
                </div>
            </b-table>
        </div>
        <b-col style="display: flex; justify-content: center;" >
            <span v-if="showEmpty">
                <p style="color:red" class="my-auto">
                    Não foram encontrados boletos gerados e pendentes para o devedor informado. Importante: os boletos das parcelas dos parcelamentos ativos somente são gerados pelo sistema a partir do dia 15 de cada mês. Caso a consulta seja realizada em dia anterior, aguarde e tente novamente a partir do dia 15.
                </p>
            </span>
        </b-col>
        <b-col style="display: flex; justify-content: center;">
            <b-pagination v-model="configTable.currentPage" :per-page="configTable.perPage"
                        :total-rows="configTable.rows" size="sm" class="pl-3" style="padding: 0 !important;"
                        v-if="configTable.perPage != 'Todos'">
            </b-pagination>
        </b-col>
        
        <CompLoading ref="loading"></CompLoading>
    </div>
</template>

<script>
import CompLoading from "../shared/components/CompLoading";
import formatarMixins from '../../mixins/formatarMixins';
import axios from 'axios'

export default {
    name: 'ConsultaBoletoExterno',
    mixins: [ formatarMixins ],
    components: { CompLoading },
    data() {
        return {
            form: {
                email: '',
                documento: '',
            },
            fields: [ 
                    {
                        key: 'numeroRequisicao',
                        label: 'Nº Requisição',
                        sortable: true
                    },
                    {
                        key: 'linhaDigitavel',
                        label: 'Código de Barras',
                        sortable: true
                    },
                    {
                        key: 'dataVencimento',
                        label: 'Data Venc.',
                        sortable: true
                    },
                    
                ],
            boletos: [],
            show: true,
            validations: {
                    cpf: {
                        valid: true,
                        invalidDocument: false,
                        semCarta: false
                    },
                    cnj: {
                        valid: true,
                        carta: false
                    },
                    email: { valid: true, message: ""},
                },
                filtros: {
                    filtrarNumeroRequisicao: null,
                    requisicao: null,
                    filtrarCodigoBarras: null,
                    codigoBarras: null,
                    filtrarDataVencimento: null,
                    dataVencimento: null,
                },
                configTable: {
                    perPage: 10,
                    lastPage: null,
                    sortField: 'item.numeroRequisicao',
                    sortOrder: 'asc',
                    currentPage: 1,
                    rows: 0,
                    checkedAll: false,
                    load: false,
                    sortDesc: false
                },
                filterOn: [],
                showEmpty: false,
                messageModal: {
                    message: null,
                    variant: null
                },
                emptyMessage:[
                    {
                        text: " Não foram encontrados boletos gerados e pendentes para o devedor informado. Importante: os boletos das parcelas dos parcelamentos ativos somente são gerados pelo sistema a partir do dia 15 de cada mês. Caso a consulta seja realizada em dia anterior, aguarde e tente novamente a partir do dia 15.",
                        class: 'cor-vermelho'
                    }
                ]
        }
    },
    computed:{
        sortOptions() {
        return this.fields
          .filter(f => f.sortable)
          .map(f => {
            return { text: f.label, value: f.key }
          })
      },
      validarObrigatorios() {
            return !(this.form.documento == "" || this.form.email == "");  
        },
    },
    methods: {
        onSubmit(event) {
        event.preventDefault()
        this.consultar();
        },
        onReset(event) {
        event.preventDefault()
        this.form.email = ''
        this.form.documento = ''
        this.show = false
        this.$nextTick(() => {
            this.show = true
        })
    },
    boletoSelecionado(item){
        if(item.length != 0){
            this.baixarPdfBoleto(item);
        } else {
            return;
        }
    },
    mostrarErro(mensagem){
        this.$nextTick(() => {
            this.messageModal.variant = 'danger';
            this.messageModal.message = mensagem;
        })
    },
    limparMessagemModal(){
        this.messageModal.variant = '';
        this.messageModal.message = '';
    },
    limpar(){
        this.form.email = '';
        this.form.documento = '';
        this.boletos = [];
        this.showEmpty = false;
        this.$refs.tabelaBoletos.clearSelected();
    },
    validarEmail() {
        if (this.form.email != null && this.form.email != '' && this.form.email.match('.+[@]+.') == null) {
            this.validations.email.valid = false;
            return false;
        } else {
            this.validations.email.valid = true;
            return true;
        }
    },
    async consultar() {
            this.limparMessagemModal();
            this.showEmpty = false;
            this.$refs.loading.showLoading();
            let { cpf, cnpj } = "";
            this.boletos = [];

            if(this.form.documento.length <= 14 && !this.validarCpf(this.form.documento)) {
                this.adicionarErroDeValidacao(this.validations.cpf, 'CPF inválido.');
                return;
            } else if(this.form.documento.length > 14 && !this.validarCnpjAlfanumerico(this.form.documento)) {
                this.adicionarErroDeValidacao(this.validations.cpf, 'CNPJ inválido.');
                return;
            }

            if(this.validarCnpjAlfanumerico(this.form.documento)){
                cnpj = this.form.documento;  
            } else if (this.validarCpf(this.form.documento))  {
                cpf = this.form.documento;
            }
            let body = {
                email: this.form.email,
                cpf: cpf,
                cnpj: cnpj
            }
            axios.post(`${this.urlApi}/v1/publico/boleto-externo/consultar-contribuinte`, body, {
                headers: {
                    'Content-Type': 'application/json',
                }
            }).then(response => {
                if(response.data === true){
                    axios.post(`${this.urlApi}/v1/publico/boleto-externo/consultar`, body, {
                    headers: {
                        'Content-Type': 'application/json',
                    }
                    }).then(response => {
                        this.boletos = response.data;

                        if(this.boletos.length == 0){
                            this.showEmpty = true;
                        }
                        
                    }).catch((error) => {
                        this.exibirErro(error)
                        this.mostrarErro(error)
                    }).finally(() => {
                        this.$refs.loading.hideLoading();
                    })
                } else {
                    this.mostrarErro("Os dados informados não conferem com os cadastrados na base do sistema SFEPGE!");
                }  
            }).catch((error) => {
                this.exibirErro(error)
                this.mostrarErro(error)
            }).finally(() => {
                this.$refs.loading.hideLoading();
            })
        },

        baixarPdfBoleto(item){
            this.limparMessagemModal();
            this.$refs.loading.showLoading();

            let body = {
            linkPdf: item[0].linkBoleto
            }

            axios.post(`${this.urlApi}/v1/publico/boleto-externo/download`, body, {
                headers: {
                    'Content-Type': 'application/json',
                },
                responseType: 'arraybuffer'
            }).then(response => {
                if (!response.data || !response.data.byteLength){
                    this.messageModal = {
                        message: 'Boleto não encontrado',
                        variant: 'danger'
                    }
                    return
                }

                let blob = new Blob([response.data], { type: 'application/pdf' })
                let link = document.createElement('a')
                link.href = window.URL.createObjectURL(blob)
                link.download = 'Boleto' + (item.codigoBarras ? item.codigoBarras : 'boleto') + '.pdf'
                link.click()
                
            }).catch((error) => {
                this.exibirErro(error)
                this.mostrarErro("Não existe o pdf do boleto. Contacte o administrador do sistema.")
            }).finally(() => {
                this.$refs.loading.hideLoading();
            })
        }
    },
    mounted() {
            this.urlApi = process.env.VUE_APP_ROOT_API;
        }

}

</script>
<style scoped>
.cor-vermelho{
    color: #F44336;
}
</style>
